import { Routes, Route } from 'react-router-dom';
import LoginPage from '../pages/login';
import HomePage from '../pages/home';
import FiltroRelatorioResultadosPage from '../pages/relatorios/filtro-relatorio-resultados';
import FiltroMapaResultadosPorLvPage from '../pages/mapa/filtro-mapa-resultados-por-lv';
import MapaResultadosPorLvPage from '../pages/mapa/mapa-resultados-por-lv';
import RelatorioResultados from '../pages/relatorios/relatorio-resultados';
import FiltroRelatorioPerfilEleitoradoPage from '../pages/relatorios/filtro-relatorio-perfil-eleitorado';
import RelatorioPerfilEleitorado from '../pages/relatorios/relatorio-perfil-eleitorado';
import Layout from '../components/layout';
import PrivateRoute from './PrivateRoute';

function AppRoutes() {
  return (
    <Routes>
      {/* Rota pública */}
      <Route path="/login" element={<LoginPage />} />

      {/* Administrador e Analista */}
      <Route
        path="/"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <Layout>
              <HomePage />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/relatorios"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <Layout>
              <FiltroRelatorioResultadosPage />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/relatorios/resultados"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <RelatorioResultados />
          </PrivateRoute>
        }
      />

      <Route
        path="/relatorios/perfil-eleitorado"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <Layout>
              <FiltroRelatorioPerfilEleitoradoPage />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/relatorios/perfil-eleitorado/resultado"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <RelatorioPerfilEleitorado />
          </PrivateRoute>
        }
      />

      <Route
        path="/mapa"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <Layout>
              <FiltroMapaResultadosPorLvPage />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/mapa/resultados-por-lv"
        element={
          <PrivateRoute allowedRoles={['administrador', 'analista']}>
            <Layout>
              <MapaResultadosPorLvPage />
            </Layout>
          </PrivateRoute>
        }
      />

    </Routes>
  );
}

export default AppRoutes;
